const SET_INITIALIZATION = 'SET_INITIALIZATION';
const SET_P13N_DATA_FOR_PREVIEW = 'SET_P13N_DATA_FOR_PREVIEW';
const SET_P13N_DATA = 'SET_P13N_DATA';
const SET_P13N_VARIATIONS = 'SET_P13N_VARIATIONS';
const SET_ACTIVE_P13N_VARIATION = 'SET_ACTIVE_P13N_VARIATION';
const SET_SID_DATA = 'SET_SID_DATA';
const UPDATE_SID_DATA = 'UPDATE_SID_DATA';
const SET_ORIGINAL_BANNER_SID = 'SET_ORIGINAL_BANNER_SID';
const SET_CAROUSEL_ACTIVE_PAGE = 'SET_CAROUSEL_ACTIVE_PAGE';
const SET_REPLEN_P13N_DATA = 'SET_REPLEN_P13N_DATA';
const SET_RTCO_P13N_DATA = 'SET_RTCO_P13N_DATA';
const SET_RECAP_P13N_AB_TEST_DATA = 'SET_RECAP_P13N_AB_TEST_DATA';

export {
    SET_INITIALIZATION,
    SET_P13N_DATA_FOR_PREVIEW,
    SET_P13N_DATA,
    SET_P13N_VARIATIONS,
    SET_ACTIVE_P13N_VARIATION,
    SET_SID_DATA,
    UPDATE_SID_DATA,
    SET_ORIGINAL_BANNER_SID,
    SET_CAROUSEL_ACTIVE_PAGE,
    SET_REPLEN_P13N_DATA,
    SET_RTCO_P13N_DATA,
    SET_RECAP_P13N_AB_TEST_DATA
};
